
























































import { Component, Vue, Watch } from "vue-property-decorator";
import Site from "@/models/site";
import SitesAPI from "@/services/sites";
import { LayoutModule } from "@/store/layout";
import TableActions from "@/components/TableActions.vue";
import { Meta, QueryParams } from "@/models/general";
import { get } from "lodash";
import { UserModule } from "@/store/user";

@Component({
  components: { TableActions },
})
export default class Sites extends Vue {
  headers = [
    {
      text: this.$t("sites.model.logo"),
      sortable: false,
      value: "logo",
    },
    {
      text: this.$t("sites.model.name"),
      value: "name",
    },
    {
      text: this.$t("sites.model.abbreviation"),
      value: "abbreviation",
    },
    {
      text: this.$t("sites.model.url"),
      value: "url",
    },
    {
      text: "",
      value: "id",
    },
  ];

  sites: Site[] = [];
  meta: Meta = new Meta();
  pagination = {};
  loading = true;
  searchQuery = "";

  get admin(): boolean {
    return UserModule.isAdmin;
  }

  created(): void {
    this.getSites();
  }

  async getSites(): Promise<void> {
    this.loading = true;
    try {
      const params: QueryParams = {
        page: {
          number: this.meta.pagination.current,
          size: this.meta.pagination.size,
        },
      };

      this.searchQuery && this.searchQuery !== ""
        ? (params.search = this.searchQuery)
        : null;

      const r = await SitesAPI.getSites(params);
      this.sites = r.data;
      this.meta = new Meta(r.meta);
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  }

  editSite(site: Site): void {
    this.$router.push({ name: "editSite", params: { id: String(site.id) } });
  }

  deleteSite(id: string): void {
    LayoutModule.setDialogTitle("sites.delete_site");
    LayoutModule.setDialogType("error");
    LayoutModule.setDialogCallback(
      async (): Promise<null> => {
        LayoutModule.showLoader();
        await SitesAPI.deleteSite(id);
        LayoutModule.hideLoader();
        return null;
      }
    );
    LayoutModule.showDialog();
  }

  @Watch("pagination", { deep: true })
  handlePagination(): void {
    this.meta.pagination.current = get(this.pagination, "page");
    this.meta.pagination.size = get(this.pagination, "itemsPerPage");

    this.getSites();
  }

  @Watch("searchQuery")
  async search(): Promise<void> {
    this.getSites();
  }
}
